import { cn as e } from "../shared/utils.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { Field as r } from "@base-ui/react/field";
//#region src/input/textarea.tsx
var i = e("flex w-full items-center rounded-md input-ring transition-base bg-field-bg-primary text-text-primary outline-none text-base px-3 text-ellipsis", "placeholder:text-text-tertiary", "data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:placeholder:text-text-disabled data-disabled:cursor-not-allowed", "py-3 h-auto min-h-[82px] resize-none"), a = t(({ className: t, unstyled: a, rows: o, autoresize: s, ...c }, l) => {
	let u = c;
	return /* @__PURE__ */ n(r.Control, {
		ref: l,
		"data-slot": "textarea-control",
		"data-testid": "textarea-control",
		render: /* @__PURE__ */ n("textarea", { rows: o }),
		className: e(a ? void 0 : i, s && "field-sizing-content", t),
		...u
	});
});
a.displayName = "Textarea";
//#endregion
export { a as Textarea };
